function addExtmap(extmap) {
  let sdp = '';
  // return sdp;
  for (let j = 0; j < extmap.length; j++) {
    const ext = extmap[j];
    const { id, uri } = ext;
    // if (isFirefox() && uri.indexOf(''))
    // console.log('[extmap] add', id, uri);
    sdp += `
a=extmap:${id} ${uri}`;
  }

  return sdp;
}

interface IFeedbackType {
  subtype: string;
  type: string;
}
interface IType {
  channels: number;
  clockrate: number;
  feedbackTypes?: IFeedbackType[];
  id: number;
  name: string;
  parameters?: {
    'packetization-mode': string;
    'profile-level-id': string;
  };
}

function addPayloadTypes(types: IType[]) {
  let sdp = '';
  for (let i = 0; i < types.length; i++) {
    const type = types[i];
    const { id, name, clockrate, channels, feedbackTypes, parameters } = type;
    sdp += `
a=rtpmap:${id} ${name}/${clockrate}${channels ? `/${channels}` : ''}`;

    let feedbackSdp = '';

    if (feedbackTypes?.length) {
      feedbackTypes.forEach((x) => {
        const { type: type1, subtype } = x;
        feedbackSdp += `
a=rtcp-fb:${id} ${[type1, subtype].join(' ')}`;
      });
    }

    sdp += feedbackSdp;

    if (parameters) {
      const fmtp: string[] = [];
      Object.getOwnPropertyNames(parameters).forEach((pName) => {
        fmtp.push(`${pName}=${parameters[pName]}`);
      });

      sdp += `
a=fmtp:${id} ${fmtp.join(';')}`;
    }
  }

  return sdp;
}

function addSsrc(type, ssrc, _ssrcGroups, streamName) {
  let sdp = '';

  // here was a part for group call
  if (ssrc) {
    sdp += `
a=ssrc:${ssrc > 0 ? ssrc : -ssrc} cname:stream${ssrc > 0 ? ssrc : -ssrc}
a=ssrc:${ssrc > 0 ? ssrc : -ssrc} msid:${streamName} ${type}${
      ssrc > 0 ? ssrc : -ssrc
    }
a=ssrc:${ssrc > 0 ? ssrc : -ssrc} mslabel:${type}${ssrc > 0 ? ssrc : -ssrc}
a=ssrc:${ssrc > 0 ? ssrc : -ssrc} label:${type}${ssrc > 0 ? ssrc : -ssrc}`;
  }

  return sdp;
}

function addDataChannel(_mid) {
  return `
m=application 9 UDP/DTLS/SCTP webrtc-datachannel
c=IN IP4 0.0.0.0
a=ice-options:trickle
a=mid:2
a=sctp-port:5000
a=max-message-size:262144`;
}

export class ChromeP2PSdpBuilder {
  static generateOffer(info) {
    const { fingerprints, ufrag, pwd, audio, video } = info;
    const media = [
      { ...audio, type: 'audio' },
      { ...video, type: 'video' },
    ];

    let sdp = `v=0
o=- 1 2 IN IP4 127.0.0.1
s=-
t=0 0`;

    if (fingerprints) {
      fingerprints.forEach((x) => {
        const { hash, fingerprint, setup } = x;
        sdp += `
a=fingerprint:${hash} ${fingerprint}
a=setup:${setup}`;
      });
    }

    if (ufrag && pwd) {
      sdp += `
a=ice-ufrag:${ufrag}
a=ice-pwd:${pwd}`;
    }

    sdp += `
a=group:BUNDLE 0 1 2 3
a=extmap-allow-mixed
a=msid-semantic: WMS *`;
    const streamName = `stream${media.map((x) => x.ssrc).join('_')}`;
    for (let i = 0; i < media.length; i++) {
      const m = media[i];
      const { type, ssrc, ssrcGroups, payloadTypes, rtpExtensions } = m;
      switch (type) {
        case 'audio': {
          sdp += `
m=audio 56930 UDP/TLS/RTP/SAVPF ${payloadTypes.map((x) => x.id).join(' ')}
c=IN IP4 0.0.0.0
a=rtcp:9 IN IP4 0.0.0.0
a=ice-options:trickle
a=mid:${i}
a=sendrecv`;
          sdp += addExtmap(rtpExtensions);

          if (ssrc) {
            sdp += `
a=msid:${streamName} audio${ssrc}`;
          }

          sdp += `
a=rtcp-mux`;
          sdp += addPayloadTypes(payloadTypes);
          sdp += addSsrc(type, ssrc, ssrcGroups, streamName);

          break;
        }
        case 'video': {
          sdp += `
m=video 61986 UDP/TLS/RTP/SAVPF ${payloadTypes.map((x) => x.id).join(' ')}
c=IN IP4 0.0.0.0
a=rtcp:9 IN IP4 0.0.0.0
a=ice-options:trickle
a=mid:${i}
a=sendrecv`;
          sdp += addExtmap(rtpExtensions);

          if (ssrc) {
            sdp += `
a=msid:${streamName} video${ssrc}`;
          }

          sdp += `
a=rtcp-mux
a=rtcp-rsize`;
          sdp += addPayloadTypes(payloadTypes);
          sdp += addSsrc(type, ssrc, ssrcGroups, streamName);
          break;
        }
      }
    }
    sdp += addDataChannel(2);
    // sdp += `\n`;

    return sdp;
  }

  static generateAnswer(info) {
    const { fingerprints, ufrag, pwd, audio, video, screencast } = info;
    const media = [
      { ...audio, type: 'audio' },
      { ...video, type: 'video' },
      { ...screencast, type: 'video' },
    ];

    let sdp = `v=0
o=- 1 2 IN IP4 127.0.0.1
s=-
t=0 0`;

    if (fingerprints) {
      fingerprints.forEach((x) => {
        const { hash, fingerprint, setup } = x;
        sdp += `
a=fingerprint:${hash} ${fingerprint}
a=setup:${setup}`;
      });
    }

    if (ufrag && pwd) {
      sdp += `
a=ice-ufrag:${ufrag}
a=ice-pwd:${pwd}`;
    }

    sdp += `
a=group:BUNDLE 0 1 2 3
a=extmap-allow-mixed
a=msid-semantic: WMS *`;
    const streamName = `stream${media.map((x) => x.ssrc).join('_')}`;
    for (let i = 0; i < media.length; i++) {
      const m = media[i];
      const { type, ssrc, ssrcGroups, payloadTypes, rtpExtensions } = m;
      switch (type) {
        case 'audio': {
          sdp += `
m=audio 56930 UDP/TLS/RTP/SAVPF ${payloadTypes.map((x) => x.id).join(' ')}
c=IN IP4 0.0.0.0
a=rtcp:9 IN IP4 0.0.0.0
a=ice-options:trickle
a=mid:${i}
a=sendrecv`;
          sdp += addExtmap(rtpExtensions);

          if (ssrc) {
            sdp += `
a=msid:${streamName} audio${ssrc}`;
          }

          sdp += `
a=rtcp-mux`;
          sdp += addPayloadTypes(payloadTypes);
          sdp += addSsrc(type, ssrc, ssrcGroups, streamName);
          break;
        }
        case 'video': {
          sdp += `
m=video 61986 UDP/TLS/RTP/SAVPF ${payloadTypes.map((x) => x.id).join(' ')}
c=IN IP4 0.0.0.0
a=rtcp:9 IN IP4 0.0.0.0
a=ice-options:trickle
a=mid:${i}
a=sendrecv`;
          sdp += addExtmap(rtpExtensions);

          if (ssrc) {
            sdp += `
a=msid:${streamName} video${ssrc}`;
          }

          sdp += `
a=rtcp-mux
a=rtcp-rsize`;
          sdp += addPayloadTypes(payloadTypes);
          sdp += addSsrc(type, ssrc, ssrcGroups, streamName);
          break;
        }
      }
    }
    sdp += addDataChannel(2);
    // sdp += `\n`;

    return sdp;
  }
}
